import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Button } from '../components/Button';
import { Dropdown } from '../components/Dropdown';
import { Switch } from '../components/Switch';
import { CloseIcon } from '../icons/CloseIcon';
import S from './ProductIdGroup.styl';
var ProductIdGroup = /** @class */ (function (_super) {
    __extends(ProductIdGroup, _super);
    function ProductIdGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            linkedProductIds: [],
        };
        _this.onProductSelected = function (product) {
            var _a;
            if (!((_a = _this.state.linkedProductIds) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p === product.id; }))) {
                var list = _this.state.linkedProductIds;
                if (list) {
                    list === null || list === void 0 ? void 0 : list.push(product.id || 0);
                }
                else {
                    list = [product.id || 0];
                }
                _this.setState({
                    linkedProductIds: list,
                });
                _this.onProductGroupChanged(list);
            }
        };
        _this.getProduct = function (id) {
            var _a;
            return (_a = _this.props.products) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p.id === id; });
        };
        _this.onRemoveProduct = function (id) {
            var _a;
            var list = (_a = _this.state.linkedProductIds) === null || _a === void 0 ? void 0 : _a.filter(function (fId) { return fId !== id; });
            _this.setState({
                linkedProductIds: list,
            });
            _this.onProductGroupChanged(list);
        };
        _this.onRemoveGroup = function () {
            if (_this.props.onRemoveGroup) {
                _this.props.onRemoveGroup(_this.props.index);
            }
        };
        _this.onProductGroupChanged = function (group) {
            if (_this.props.onProductGroupChanged) {
                _this.props.onProductGroupChanged(_this.props.index, group);
            }
        };
        _this.onSwitchChange = function (event) {
            var isChecked = event.currentTarget.checked;
            var list = _this.state.linkedProductIds || [];
            if (isChecked) {
                list === null || list === void 0 ? void 0 : list.push(-10);
            }
            else {
                list = list.filter(function (id) { return id !== -10; });
            }
            _this.setState({
                linkedProductIds: list,
            });
            _this.onProductGroupChanged(list);
        };
        _this.isInfected = function () {
            return _this.props.productIds.indexOf(-10) !== -1;
        };
        return _this;
    }
    ProductIdGroup.prototype.componentDidMount = function () {
        this.setState({
            linkedProductIds: this.props.productIds,
        });
    };
    ProductIdGroup.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var props = this.props;
        var i18n = props.store.i18n;
        return (React.createElement("div", { className: S.productGroupItem },
            props.index > 0 &&
                React.createElement("div", { className: S.productHeader }),
            React.createElement(Dropdown, { maxHeight: 190, isFixed: true, className: "modalDropDown", boxClass: "modalDropDownBox", label: "" + i18n.inputChoose },
                React.createElement(Dropdown.List, null, (_a = this.props.products) === null || _a === void 0 ? void 0 : _a.map(function (product, index) { return (React.createElement(Dropdown.Item, { key: index, data: "product", autoClose: true, onClick: function (_) { return _this.onProductSelected(product); } }, product === null || product === void 0 ? void 0 : product.title)); }))),
            React.createElement("div", { className: S.productIfInfected },
                React.createElement("span", null, i18n.modelsIfInfected),
                React.createElement(Switch, { height: 24, onChange: this.onSwitchChange, defaultChecked: this.isInfected() })),
            React.createElement("div", { className: S.productList }, (_b = this.state.linkedProductIds) === null || _b === void 0 ? void 0 : _b.filter(function (id) { return id !== -10; }).map(function (id, index) {
                var _a;
                return (React.createElement("div", { className: S.productSelected, key: index },
                    React.createElement("span", null, (_a = _this.getProduct(id)) === null || _a === void 0 ? void 0 : _a.title),
                    React.createElement("span", { onClick: function (_) { return _this.onRemoveProduct(id); } },
                        React.createElement(CloseIcon, { className: S.productClose, width: 16, height: 16, color: 'white' }))));
            })),
            props.index > 0 &&
                React.createElement("div", { className: S.productGroupRemove },
                    React.createElement(Button, { className: S.productGroupRemoveButton, type: "button", onClick: this.onRemoveGroup },
                        React.createElement(CloseIcon, { className: S.productClose, width: 16, height: 24, color: 'white' }),
                        React.createElement("span", null, i18n.actionDelete)))));
    };
    ProductIdGroup = __decorate([
        inject('store'),
        observer
    ], ProductIdGroup);
    return ProductIdGroup;
}(React.Component));
export { ProductIdGroup };
